import React from 'react';
import parse, { domToReact } from 'html-react-parser';
import './ck-editor.css';

function parseInlineStyle(styleValue) {
	if (!styleValue || typeof styleValue !== 'string') {
		return undefined;
	}

	return styleValue.split(';').reduce((styleObject, declaration) => {
		const [rawProperty, rawValue] = declaration.split(':');
		if (!rawProperty || !rawValue) {
			return styleObject;
		}

		const property = rawProperty
			.trim()
			.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
		const value = rawValue.trim();
		if (!property || !value) {
			return styleObject;
		}

		styleObject[property] = value;
		return styleObject;
	}, {});
}

export default function CustomMarkdown({ children }) {
	const options = {
		replace: ({ attribs, children }) => {
			if (!attribs) {
				return;
			}
			if (attribs.href) {
				const { style, ...restAttribs } = attribs;
				const styleObject = parseInlineStyle(style);

				// overwrite the a tag to open links in a new tab
				return (
					<a
						{...restAttribs}
						style={styleObject}
						onClick={() =>
							window.analytics.track('Link Clicked', {
								link_name: children[0].data
									? children[0].data
									: children[0].children[0].data,
								link: attribs.href,
								path: window.location.pathname,
								url: window.location.href,
							})
						}
						target='_blank'
						rel='noopener noreferrer'
					>
						{domToReact(children, options)}
					</a>
				);
			}
		},
	};
	return <div className='ck-content'>{parse(children, options)}</div>;
}
